// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7eda7408","644":"f0d73493","732":"88ac9d15","977":"92f08f9a"}[chunkId] + ".chunk.js";
};